// extracted by mini-css-extract-plugin
module.exports = {"main":"Grinding_main__2YBp9","imgContainer":"Grinding_imgContainer__1xT6s","inputs":"Grinding_inputs__3BvWE"};